import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Row from '../Row';
import Col from '../Col';
import InboxHeader from './InboxHeader';
import InboxItemsList from './InboxItemsList';
import {
  fetchInboxList,
  onClearInboxList,
  fetchAnnouncementList,
  onFetchInboxSuitesList,
  onFetchInboxServiceRequestList,
  fetchChatMessages,
  onClearChatMessages,
  onFetchChatUserInformation,
  onFetchInboxAnnouncementsByProperty,
  onClearInboxAnnouncementsByProperty,
  onClearChatUserInformationDone,
  clearInboxPaginationCount,
  onClearInboxServiceRequestsList,
  onSaveSelectedItem,
  onUpdateUnreadToReadMessages,
} from '../../store/actions/Inbox';
import InboxListComponents from './InboxListComponents';
import './Inbox.scss';
import { fetchtAllowedTabList } from '../../store/actions/tabSelections';

const InboxDashboard = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth?.user || {});
  const inboxList = useSelector((state) => state.inbox?.inboxList || []);
  const announcementsList = useSelector(
    (state) => state.inbox?.inboxAnnouncementsList || []
  );
  const inboxSelectedItem = useSelector(
    (state) => state.inbox?.inboxSelectedItem || {}
  );

  const [type, setType] = useState('Messages');
  const [search, setSearch] = useState('');
  const [announcement, setAnnouncement] = useState({});

  const inboxMsgCount = inboxList.length > 0 ? false : true;
  const inboxAnsCount = announcementsList.length > 0 ? false : true;
  const roleName = user.roles[0].role.name;

  useEffect(() => {
    dispatch(onSaveSelectedItem({}));
    onFetchInboxList(search, 'initial');
  }, []);

  const onSelectType = (type) => {
    setType(type);
    setSearch('');
    fetchCalls(type, '');
    dispatch(onClearChatMessages());
    dispatch(onSaveSelectedItem({}));
  };
  const onSearch = (e) => {
    setSearch(e.target.value);
    fetchCalls(type, e.target.value);
  };
  const fetchCalls = (type, search) => {
    switch (type) {
      case 'Messages':
        return onFetchInboxList(search);
      case 'Announcements':
        return onFetchAnnouncementList(search);
      case 'General':
        return onFetchSuitesList(search);
      case 'Service Request':
        return onFetchServiceRequestList(search);
      default:
        return;
    }
  };
  const onFetchInboxList = (search, type) => {
    dispatch(fetchInboxList(user.id, roleName, search, inboxMsgCount, type));
  };
  const onFetchAnnouncementList = (search) => {
    dispatch(fetchAnnouncementList(user.id, roleName, search, inboxAnsCount));
  };
  const onFetchSuitesList = (search) => {
    dispatch(onFetchInboxSuitesList(user.id, roleName, search, true));
  };
  const onFetchServiceRequestList = (search) => {
    dispatch(clearInboxPaginationCount());
    dispatch(onClearInboxServiceRequestsList());
    dispatch(
      onFetchInboxServiceRequestList(
        user.id,
        roleName,
        1,
        search,
        search ? false : true
      )
    );
  };
  const selectItem = async (data) => {
    await dispatch(fetchtAllowedTabList(data.propertyId));

    if (type === 'General' || type === 'Service Request') {
      setSearch('');
    }

    dispatch(onClearChatUserInformationDone());
    setAnnouncement({});
    dispatch(onClearInboxAnnouncementsByProperty());
    dispatch(onClearChatMessages());
    dispatch(onSaveSelectedItem(data));

    if (
      type === 'Messages' ||
      type === 'General' ||
      type === 'Service Request'
    ) {
      setType('Messages');
      dispatch(fetchChatMessages(data.referenceId, data.referenceType));
      dispatch(
        onFetchChatUserInformation(data.referenceId, data.referenceType)
      );
      dispatch(
        onUpdateUnreadToReadMessages(
          data.referenceId,
          data.referenceType,
          user.id
        )
      );
    } else if (type === 'Announcements') {
      dispatch(
        onFetchInboxAnnouncementsByProperty(
          user.id,
          user.roles[0].role.name,
          data.propertyId
        )
      );
    } else {
    }
  };

  const onSetAnnouncement = (announcementObj) => {
    setAnnouncement(announcementObj);
  };

  const closeAnnouncement = () => {
    setAnnouncement({});
  };

  const closeItem = () => {
    dispatch(onSaveSelectedItem({}));
  };

  return (
    <div className="inboxSection">
      <h2 className="headingMobile">Messages</h2>
      <Row>
        <Col
          md={4}
          xs={12}
          id={
            (inboxSelectedItem.id ||
              type === 'General' ||
              type === 'Service Request') &&
            'mobile_responsive_messagelist'
          }
        >
          <InboxHeader type={type} onSelectType={onSelectType} />
          <InboxItemsList
            type={type}
            searchString={search}
            onSearch={onSearch}
            onSelectItem={selectItem}
            selectedId={inboxSelectedItem}
          />
        </Col>
        <Col
          md={8}
          xs={12}
          id={inboxSelectedItem.id && 'mobile_responsive_chatlist'}
        >
          {((inboxSelectedItem && inboxSelectedItem.id) ||
            type === 'General' ||
            type === 'Service Request') && (
            <>
              <div
                id="mobile_responsive_backbutton"
                className="mobile_inbox_header"
              >
                <InboxHeader type={type} onSelectType={onSelectType} />
              </div>
              <InboxListComponents
                selectedItem={inboxSelectedItem}
                onSelectItem={selectItem}
                type={type}
                onSetAnnouncement={onSetAnnouncement}
                announcement={announcement}
                onCloseAnnouncement={closeAnnouncement}
                searchString={search}
                onSearch={onSearch}
                onCloseItem={closeItem}
              />
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default InboxDashboard;
